/**
 * Money arrives from the API in micros — one currency unit is 1,000,000 — so
 * that a sub-cent figure survives the trip. This is the only place it becomes
 * something a person reads.
 *
 * Copied from `maxlayer-clients/src/lib/money.ts`, minus the rate formatting
 * this dashboard has no use for: nothing here is priced per hour.
 */

export const MICROS_PER_UNIT = 1_000_000;

/**
 * A balance or a total, at normal currency precision.
 *
 * Rounds rather than truncates, for the reason the customer dashboard's does: a
 * balance of 4.999 should read as $5.00, because the person reading it is about
 * to compare it against what they were told they earned.
 */
export function formatMoney(micros: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(micros / MICROS_PER_UNIT);
}

/**
 * A commission rate, as a percentage.
 *
 * Basis points in, a percentage out, and the fraction is dropped when it is
 * zero: "50%" rather than "50.0%", because a rate with a decimal on it invites
 * somebody to look for the decimal in the amount.
 */
export function formatRate(bps: number): string {
  const percent = bps / 100;
  return `${Number.isInteger(percent) ? percent : percent.toFixed(1)}%`;
}

/** A whole number with thousands separators. Clicks, referrals, conversions. */
export function formatCount(value: number): string {
  return new Intl.NumberFormat("en-US").format(value);
}
